export const getWXCode = (state) => {
    const appId = process.env.appId;
    const redirectUrl = encodeURIComponent(process.env.redirectUrl + '/#/' + location.href.split('#/')[1]);
    const agentId = process.env.agentId;

    window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base&agentid=${agentId}&state=STATE&connect_redirect=1#wechat_redirect`)
}


// WEBPACK FOOTER //
// ./src/utils/getWXCode.js